// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../imageSize.fragment.generated';
export const ComponentQuoteFragmentDoc = `
    fragment componentQuote on ComponentQuote {
  hasBackgroundImage
  quoteImage: image {
    ...cmsImageSizes
  }
  quote
  author
  size
  showQuotationMarks
}
    `;